class ConstructionTabs {
  constructor(parent, onChange) {
    this.onChange = onChange;
    this.container = parent.querySelector('[data-houses]');
    if (!this.container) return;
    this.tabs = [...this.container.querySelectorAll('[data-house-tab]')];
    this.moreTrigger = this.container.querySelector('[data-more-trigger]');
    this.attachListeners();
  }

  attachListeners() {
    this.tabs?.forEach((tab, i) => {
      if (tab.classList.contains('-active')) {
        this.container.scrollLeft = tab.offsetLeft - 24;
      }
      tab.addEventListener('click', () => {
        this.update(i);
        this.onChange(i, tab.dataset.houseId);
      });
    });
    this.showMore();
  }

  showMore() {
    if (!this.moreTrigger) return;
    this.moreTrigger.addEventListener('click', this.handleShowMore);
  }

  handleShowMore = () => {
    this.moreTrigger.remove();
  }

  update = (newIndex, shouldScrollToTab = false) => {
    this.tabs?.forEach((tab, i) => {
      if (i === newIndex) {
        tab.classList.add('-active');
        if (window.getComputedStyle(tab).display === 'none') {
          this.handleShowMore();
        }
        if (shouldScrollToTab) {
          this.container.scrollLeft = tab.offsetLeft - 8;
        }
      } else {
        tab.classList.remove('-active');
      }
    });
  }
}

export default ConstructionTabs;
